import { Routes, Route } from "react-router-dom";

// layout
import AnimatedLayout from "./components/Layouts/AnimatedLayout";

// pages
import HomePage from "./pages/Home/HomePage";
import AboutPage from "./pages/About/AboutPage";
import ProjectsPage from "./pages/Projects/ProjectsPage";
import ArticlesPage from "./pages/Articles/ArticlesPage";
import ContactPage from "./pages/Contact/ContactPage";

function App() {
	return (
		<>
			<Routes>
				<Route
					path="/"
					element={<AnimatedLayout />}>
					<Route
						index
						element={<HomePage />}
					/>
					<Route
						path="about"
						element={<AboutPage />}
					/>
					<Route
						path="projects"
						element={<ProjectsPage />}
					/>
					<Route
						path="articles"
						element={<ArticlesPage />}
					/>
					<Route
						path="contact"
						element={<ContactPage />}
					/>
				</Route>
			</Routes>
		</>
	);
}

export default App;
